import { render, staticRenderFns } from "./nav-dropdown-collection-advanced-minimal.vue?vue&type=template&id=29dd8080&scoped=true&"
import script from "./nav-dropdown-collection-advanced-minimal.vue?vue&type=script&lang=js&"
export * from "./nav-dropdown-collection-advanced-minimal.vue?vue&type=script&lang=js&"
import style0 from "./nav-dropdown-collection-advanced-minimal.vue?vue&type=style&index=0&id=29dd8080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd8080",
  null
  
)

export default component.exports